import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { OrderedListOutlined, FileExcelOutlined } from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockPriceHistoryByStockListFilter from "../Filters/StockPriceHistoryByStockListFilter";
import config from "util/ApiforContext";

const StockPriceHistoryReport = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "ÜRÜN FİYAT GEÇMİŞİ RAPORU",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");

  useEffect(
    () => getTableData(),
    [props.match.params.stockId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    setQuery(query + order);
    RequestHandler.get(
      `/StockPriceHistory?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.substring(0, 30).length < 30
                ? text.substring(0, 30) + ""
                : text.substring(0, 30) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Hareket Tarihi",
      dataIndex: "addDateString",
      key: "addDateString",
      align: "left",
    },
    {
      title: "Eski Vergisiz Alış Fiyatı",
      dataIndex: "oldPurchasePriceExcTaxesString",
      key: "oldPurchasePriceExcTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergisiz Alış Fiyatı",
      dataIndex: "newPurchasePriceExcTaxesString",
      key: "newPurchasePriceExcTaxesString",
      align: "left",
    },
    {
      title: "Eski Vergiler Dahil Alış Fiyatı",
      dataIndex: "oldPurchasePriceIncTaxesString",
      key: "oldPurchasePriceIncTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergiler Dahil Alış Fiyatı",
      dataIndex: "newPurchasePriceIncTaxesString",
      key: "newPurchasePriceIncTaxesString",
      align: "left",
    },
    {
      title: "Eski Vergisiz Satış Fiyatı",
      dataIndex: "oldSellingPriceExcTaxesString",
      key: "oldSellingPriceExcTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergisiz Satış Fiyatı",
      dataIndex: "newSellingPriceExcTaxesString",
      key: "newSellingPriceExcTaxesString",
      align: "left",
    },
    {
      title: "Eski Vergiler Dahil Satış Fiyatı",
      dataIndex: "oldSellingPriceIncTaxesString",
      key: "oldSellingPriceIncTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergiler Dahil Satış Fiyatı",
      dataIndex: "newSellingPriceIncTaxesString",
      key: "newSellingPriceIncTaxesString",
      align: "left",
    },

    {
      title: "Alış Fiyatı Yüzdelik Değişimi",
      dataIndex: "purchasePriceChangeRate",
      key: "purchasePriceChangeRate",
      align: "left",
      render: (text) =>
        text.toString().includes("-") ? (
          <div style={{ color: "red" }}>{renderDecimal(text)} %</div>
        ) : (
          <div style={{ color: "green" }}>{renderDecimal(text)} %</div>
        ),
    },
    {
      title: "Satış Fiyatı Yüzdelik Değişimi",
      dataIndex: "sellingPriceChangeRate",
      key: "sellingPriceChangeRate",
      align: "left",
      render: (text) =>
        text.toString().includes("-") ? (
          <div style={{ color: "red" }}>{renderDecimal(text)} %</div>
        ) : (
          <div style={{ color: "green" }}>{renderDecimal(text)} %</div>
        ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, _, sorter) => {
    let orderValue = "";
    if (sorter.columnKey && sorter.order) {
      orderValue =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        order: orderValue,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      "/StockPriceHistory/ExportReportExcel",
      {
        query: query,
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/StockPriceHistory/DownloadReportExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };
  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "end" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <StockPriceHistoryByStockListFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={true}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockPriceHistoryReport;
